export default import.meta.ROLLUP_FILE_URL_hTDjNgn4e4aVA9RMIz2S_Q